import { render, staticRenderFns } from "./LocaleChangerModal.vue?vue&type=template&id=88fff21c&scoped=true"
import script from "./LocaleChangerModal.vue?vue&type=script&lang=js"
export * from "./LocaleChangerModal.vue?vue&type=script&lang=js"
import style0 from "./LocaleChangerModal.vue?vue&type=style&index=0&id=88fff21c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fff21c",
  null
  
)

export default component.exports